export const TAX_CONTACT_TYPES = [
  {
    label: '수임처 전체',
    id: 'ALL'
  },
  {
    label: '전체',
    description: '(주담당자, 담당자)',
    id: 'ALL_MANAGER'
  },
  {
    label: '주담당자',
    id: 'MAIN_MANAGER'
  },

  {
    label: '담당자',
    id: 'MANAGER'
  }
];